(function () {
  "use strict";

  var FIVE_STAR_REPLIES = {
  "Rachel P.": "Thank you, Rachel. We wanted Nova to feel grown-up, private, and realistic for women in midlife—not like another complicated wellness project.",
  "Theresa K.": "Thank you, Theresa. Simple should still feel premium, and we’re glad Nova fits naturally into your routine without asking you to learn another system.",
  "Courtney B.": "Thank you, Courtney. Being able to choose your own time and keep the routine private is one of the biggest reasons Nova exists.",
  "Bonnie H.": "Thank you, Bonnie. We’re glad Nova gives you a private routine that you can manage comfortably on your own schedule.",
  "Marcia E.": "Thank you, Marcia. Respecting your time means no app, no account, and no unnecessary steps between you and your routine.",
  "Maxine J.": "Thank you, Maxine. We’re glad Nova feels practical and straightforward without making intimate care feel clinical."
};

  function firstName(fullName) {
    return String(fullName || "there")
      .trim()
      .split(/\s+/)[0]
      .replace(/\.$/, "");
  }

  function includesAny(text, phrases) {
    return phrases.some(function (phrase) {
      return text.indexOf(phrase) !== -1;
    });
  }

  function fourStarReply(name, reviewText) {
    var first = firstName(name);
    var text = String(reviewText || "").toLowerCase();

    if (includesAny(text, [
      "usb-c",
      "proprietary magnetic connector"
    ])) {
      return (
        "Thank you for saying this, " + first + ". USB-C would make travel " +
        "simpler, and we’ve noted that feedback for future improvements. " +
        "We’re glad the current magnetic connection has still been easy to use at home."
      );
    }

    if (includesAny(text, [
      "travel pouch",
      "storage pouch",
      "soft storage pouch",
      "small pouch",
      "pouch"
    ])) {
      return (
        "Thank you, " + first + ". A simple travel pouch is a practical " +
        "suggestion, especially for women who want to keep everything together " +
        "discreetly. We’re glad Nova itself has been easy to store."
      );
    }

    if (includesAny(text, [
      "quick-reference",
      "quick reference",
      "quick-start",
      "quick start",
      "instruction booklet",
      "instructions twice",
      "print could be larger",
      "description of each pattern",
      "button steps summarized"
    ])) {
      return (
        "Thank you, " + first + ". A clearer quick-start guide is exactly " +
        "the kind of practical feedback we value. We’re glad the controls " +
        "became straightforward once you had used them."
      );
    }

    if (includesAny(text, [
      "battery",
      "charge level",
      "charging indicator",
      "indicator could",
      "signal when the battery"
    ])) {
      return (
        "Thank you for pointing that out, " + first + ". A clearer battery " +
        "or charging signal would make the routine even easier, and we’ve " +
        "noted it. We’re glad the rest of the setup has felt straightforward."
      );
    }

    if (includesAny(text, [
      "cable",
      "charger",
      "charging head",
      "magnetic charging",
      "magnetic charger"
    ])) {
      return (
        "Thank you, " + first + ". That is fair feedback on the charging " +
        "setup, and we’ve noted it for future improvements. We’re glad the " +
        "magnetic connection works well once Nova is positioned securely."
      );
    }

    if (includesAny(text, [
      "small stand",
      "could dry",
      "resting on the counter"
    ])) {
      return (
        "Thank you, " + first + ". A small drying stand is a thoughtful " +
        "suggestion and would make care even neater in a shared bathroom. " +
        "We’re glad the smooth surface itself has been easy to clean."
      );
    }

    if (includesAny(text, [
      "box",
      "packaging",
      "inner tray",
      "storage case",
      "less material",
      "sleeve",
      "drawer space"
    ])) {
      return (
        "Thank you, " + first + ". We hear you on the packaging footprint. " +
        "Protecting a factory-sealed intimate-care device matters, but a more " +
        "compact and lower-waste storage option is useful feedback."
      );
    }

    if (includesAny(text, [
      "silent",
      "sound",
      "quieter",
      "noticeable sound"
    ])) {
      return (
        "Thank you for the honest note, " + first + ". The stronger modes " +
        "are naturally more noticeable, and many women prefer the lower " +
        "settings for a quieter routine. We’re glad you found the level that feels right for you."
      );
    }

    if (includesAny(text, [
      "red light",
      "red glow",
      "bright",
      "reflect in the mirror"
    ])) {
      return (
        "Thank you for mentioning this, " + first + ". The red glow can look " +
        "much more noticeable in a dark room, so using a soft room light is a " +
        "helpful tip for other women reading this. We’re glad the controls have felt simple."
      );
    }

    if (includesAny(text, [
      "warmth",
      "warms gradually",
      "warming feature",
      "build a little faster",
      "very hot sensation"
    ])) {
      return (
        "Thank you, " + first + ". Nova’s warmth is designed to build gently " +
        "rather than feel sudden, though we understand some women would prefer " +
        "it sooner or stronger. We’re glad you can adjust the routine at your own pace."
      );
    }

    if (includesAny(text, [
      "weight",
      "heavier",
      "feels sturdy",
      "more noticeable in weight"
    ])) {
      return (
        "Thank you, " + first + ". We’re glad the shape keeps Nova comfortable " +
        "to manage even though it feels sturdier than a basic handheld device. " +
        "That balance between durability and comfort matters."
      );
    }

    if (includesAny(text, [
      "larger",
      "longer",
      "wider",
      "size",
      "expected the device to be smaller",
      "head is a little"
    ])) {
      return (
        "Thank you, " + first + ". Size can be difficult to judge online, so " +
        "we’re glad the comparison photos and listed dimensions helped. It’s " +
        "good to hear the shape and controls felt natural once Nova was in hand."
      );
    }

    if (includesAny(text, [
      "button sequence",
      "buttons feel similar",
      "buttons to have",
      "control panel",
      "separate power button",
      "occasionally move to the next mode"
    ])) {
      return (
        "Thank you, " + first + ". That learning curve is useful for us to hear, " +
        "and we’ve noted your feedback on the controls. We’re glad the sequence " +
        "became easy after the first few uses."
      );
    }

    if (includesAny(text, [
      "mode",
      "settings",
      "strongest",
      "stronger",
      "intense",
      "intensity",
      "first setting"
    ])) {
      return (
        "Thank you, " + first + ". Not every mode will suit every woman, which " +
        "is exactly why Nova includes a range rather than one fixed intensity. " +
        "We’re glad you found the setting that feels right for you."
      );
    }

    return (
      "Thank you for the thoughtful feedback, " + first + ". We’ve noted the " +
      "point you raised and appreciate you sharing both what could be better " +
      "and what is already working well for you."
    );
  }

  function replyFor(row) {
    var nameElement = row.querySelector(
      ".tr-product__reviewer strong"
    );

    var bodyElement = row.querySelector(
      ".tr-product__review-body > p"
    );

    var name = nameElement
      ? nameElement.textContent.trim()
      : "";

    var body = bodyElement
      ? bodyElement.textContent.trim()
      : "";

    var rating = Number(row.dataset.rating || 0);

    if (rating === 5 && FIVE_STAR_REPLIES[name]) {
      return FIVE_STAR_REPLIES[name];
    }

    if (rating === 4) {
      return fourStarReply(name, body);
    }

    return "";
  }

  function addReplies(section) {
    if (!section) return;

    var rows = Array.prototype.slice.call(
      section.querySelectorAll(
        "[data-tr-imported-review]"
      )
    );


    rows.forEach(function (row) {
      if (row.querySelector("[data-tr-brand-reply]")) {
        return;
      }

      var reply = replyFor(row);

      if (!reply) return;

      var details = document.createElement("details");

      details.className =
        "tr-product__brand-reply " +
        "tr-product__brand-reply-v10";

      details.setAttribute(
        "data-tr-brand-reply",
        "true"
      );

      var summary = document.createElement("summary");

      summary.className =
        "tr-product__brand-reply-summary";

      var avatar = document.createElement("span");

      avatar.className =
        "tr-product__brand-reply-avatar";

      avatar.setAttribute("aria-hidden", "true");
      avatar.textContent = "T";

      var content = document.createElement("span");

      content.className =
        "tr-product__brand-reply-content";

      var meta = document.createElement("span");

      meta.className =
        "tr-product__brand-reply-meta";

      var badge = document.createElement("strong");

      badge.className =
        "tr-product__brand-reply-badge";

      badge.textContent = "Trundes Team";

      meta.appendChild(badge);

      var preview = document.createElement("span");

      preview.className =
        "tr-product__brand-reply-preview";

      preview.textContent = reply;

      var control = document.createElement("span");

      control.className =
        "tr-product__brand-reply-control";

      var controlText = document.createElement("span");

      controlText.textContent = "Read response";

      var chevron = document.createElement("span");

      chevron.className =
        "tr-product__brand-reply-chevron";

      chevron.setAttribute("aria-hidden", "true");

      control.appendChild(controlText);
      control.appendChild(chevron);

      content.appendChild(meta);
      content.appendChild(preview);
      content.appendChild(control);

      summary.appendChild(avatar);
      summary.appendChild(content);

      var full = document.createElement("div");

      full.className =
        "tr-product__brand-reply-full";

      var paragraph = document.createElement("p");

      paragraph.textContent = reply;

      full.appendChild(paragraph);

      details.appendChild(summary);
      details.appendChild(full);

      details.addEventListener("toggle", function () {
        controlText.textContent = details.open
          ? "Hide response"
          : "Read response";
      });

      row.appendChild(details);
    });
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll(".tr-product__reviews")
      .forEach(addReplies);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      function () {
        initAll(document);
      }
    );
  } else {
    initAll(document);
  }

  document.addEventListener(
    "shopify:section:load",
    function (event) {
      initAll(event.target);
    }
  );
})();

// Trundes customer review replies version 10
